export default __webpack_public_path__ + "static/media/VB-icon-green.aadb41ba.svg";